<template>
    <modal :show.sync=show :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Renew Fund</h3>
        <b-row>
            <b-col cols="12">
                <b-form-group label="Renew Months">
                    <el-radio-group v-model="renew_mths" fill="#13663E">
                        <el-radio-button label="12"></el-radio-button>
                        <el-radio-button label="24"></el-radio-button>
                        <el-radio-button label="36"></el-radio-button>
                    </el-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-5">
            <b-col cols="6">
                <p class="text-muted text-xs">Fund Name</p>
                <p class="font-weight-600">JV Fund 1.0-15%</p>
            </b-col>
            <b-col cols="6">
                <p class="text-muted text-xs">Release Condition</p>
                <p class="font-weight-600">Half Yearly</p>
            </b-col>
            <b-col cols="6">
                <p class="text-muted text-xs">Initial Mature Date</p>
                <p class="font-weight-600">27 Jul 2025</p>
            </b-col>
            <b-col cols="6">
                <p class="text-muted text-xs">New Mature Date</p>
                <p class="font-weight-600">27 Jul 2026</p>
            </b-col>
        </b-row>
        <b-col cols="12" class="text-center">
            <el-button type="primary" class="w-50" @click="renewFund()">Switch</el-button>
        </b-col>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Button, RadioButton, RadioGroup } from 'element-ui'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    props: {
        renew_fund: Boolean
    },
    components: {
        Modal,
        [Button.name]: Button,
        [RadioButton.name]: RadioButton,
        [RadioGroup.name]: RadioGroup,
    },
    data() {
        return {
            renew_mths: ''
        }
    },
    computed: {
        show: {
            get() {
                return this.renew_fund;
            },
            set(newVal) {
                this.$emit('update:renew_fund', newVal);
            },
        },
    },
    methods: {
        renewFund() {
            swal.fire({
                title: 'Renew Fund',
                text: "Are you sure you want to renew this fund? This change requires Credit Manager's approval.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            })
        }
    }
}
</script>